var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-toolbar',{attrs:{"color":"blue-grey darken-3","dark":"","dense":""}},[_c('span',[_vm._v("Product Category")]),_c('v-spacer'),_c('v-icon',[_vm._v("mdi-archive-cog")])],1),_c('v-data-table',{attrs:{"items":_vm.prdCatList,"headers":_vm.headers,"loading":this.prdCatGetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }